module.exports = __webpack_public_path__ + "img/dcim07.b7e9fb6e.jpg";